<template>
  <v-container fluid style="height: 100%;" class="pl-0 pr-2 py-0 m-0 box" align-stretch>
    <v-layout row wrap ma-0 py-4 py-0>
      <v-flex xs12>
        <p class="font-weight-medium my-0 ml-4">สรุปอุบัติเหตุตามช่วงเวลา</p>

        <div>
          <v-tabs class="ml-4 mt-4" hide-slider v-model="active_tab" style="width: 95%;">
            <v-tab key="tabSeason" href="#tabSeason">อุบัติเหตุตามช่วงเวลา</v-tab>
            <v-tab key="tabPeriod" href="#tabPeriod">อุบัติเหตุแยกตามวันในสัปดาห์</v-tab>

            <v-tab-item value="tabSeason" class="px-5 pt-5">
              <v-layout>
                <v-flex xs6>
                  <highcharts :options="chartPieOptions"></highcharts>
                </v-flex>
                <v-flex xs6>
                  <v-layout style="border-bottom: 1px solid #979797;">
                    <v-flex xs3>
                      <p class="font-weight-medium my-0 ml-4 number">ช่วงเวลา</p>
                    </v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium my-0 ml-4 number">อุบัติเหตุ (ครั้ง)</p>
                    </v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium my-0 ml-4 number">ผู้เสียชีวิต (คน)</p>
                    </v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium my-0 ml-4 number">ผู้บาดเจ็บ (คน)</p>
                    </v-flex>
                  </v-layout>
                  <div v-for="item in accidentItems">
                    <v-layout style="border-bottom: 1px solid #979797;">
                      <v-flex xs3>
                        <p class="my-0 ml-4">{{ item.hour }}</p>
                      </v-flex>
                      <v-flex xs3>
                        <p class="my-0 ml-4">{{ item.count }}</p>
                      </v-flex>
                      <v-flex xs3>
                        <p class="my-0 ml-4">{{ item.dead }}</p>
                      </v-flex>
                      <v-flex xs3>
                        <p class="my-0 ml-4">{{ item.injury }}</p>
                      </v-flex>
                    </v-layout>
                  </div>
                  <v-layout v-if="sumDead && sumInjury && sumCount">
                    <v-flex xs3></v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium my-0 ml-4">{{ sumCount | numFormat }}</p>
                    </v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium my-0 ml-4">{{ sumDead | numFormat }}</p>
                    </v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium my-0 ml-4">{{ sumInjury | numFormat }}</p>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab-item value="tabPeriod" class="px-5 pt-5">
              <highcharts style="padding: 0 30px;" :options="chartHeatmapOptions"></highcharts>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'Cause',
  props: {
    searchCondition: {
      type: Object
    }
  },
  data: () => ({
    active_tab: 'tabPeriod',
    title: 'มูลเหตุสันนิฐาน',
    chartPieOptions: null,
    chartHeatmapOptions: null,
    colors: ['#6F676F', '#f3a055', '#758f39', '#BDC667', '#B57B0D', '#CC98C7'],
    accidentItems: [],
    sumCount: null,
    sumDead: null,
    sumInjury: null
  }),
  created() {
    this.getChartOptions();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.active_tab = 'tabPeriod';
      this.active_tab = 'tabSeason';

      // this.search();
    },
    getChartOptions() {
      this.chartPieOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: 300,
          style: {
            fontFamily: 'Kanit'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          crosshair: true
        },
        yAxis: {
          title: null
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              formatter: function() {
                return this.percentage ? this.percentage.toFixed(1) + '%' : '';
              },
              distance: 0
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">จำนวนอุบัติเหตุ</span><br/>',
          pointFormat: '{point.name}: <b>{point.y:,.0f} ครั้ง</b>'
        },
        colors: null,
        series: {
          data: []
        },
        title: {
          verticalAlign: 'middle',
          floating: false,
          text: '',
        },
        lang: {
            noData: ''
        },
      };

      this.chartHeatmapOptions = {
        chart: {
          type: 'heatmap',
          marginTop: 40,
          marginBottom: 80,
          plotBorderWidth: 1,
          height: 300,
          style: {
            fontFamily: 'Kanit'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          categories: null
        },
        yAxis: {
          categories: null,
          title: null
        },
        colorAxis: {
          min: 0,
          minColor: '#F7AAAA',
          maxColor: '#910000'
        },
        legend: {
          align: 'right',
          layout: 'vertical',
          margin: 0,
          verticalAlign: 'top',
          y: 20
          // symbolHeight: 280
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.value:,.0f}'
            }
          }
        },
        tooltip: {
          enabled: false,
          pointFormat: null
        },
        series: null
      };
    },
    initData() {
      this.accidentItems = [
        {
          hour: '00:01 - 04:00',
          count: 0,
          dead: 0,
          injury: 0
        },
        {
          hour: '04:01 - 08:00',
          count: 0,
          dead: 0,
          injury: 0
        },
        {
          hour: '08:01 - 12:00',
          count: 0,
          dead: 0,
          injury: 0
        },
        {
          hour: '12:01 - 16:00',
          count: 0,
          dead: 0,
          injury: 0
        },
        {
          hour: '16:01 - 20:00',
          count: 0,
          dead: 0,
          injury: 0
        },
        {
          hour: '21:00 - 24:00',
          count: 0,
          dead: 0,
          injury: 0
        }
      ];
      this.chartHeatmapOptions.xAxis.categories = [
        '1-วันอาทิตย์',
        '2-วันจันทร์',
        '3-วันอังคาร',
        '4-วันพุธ',
        '5-วันพฤหัสบดี',
        '6-วันศุกร์',
        '7-วันเสาร์'
      ];
      this.chartHeatmapOptions.yAxis.categories = [
        '21:00 - 24:00',
        '16:01 - 20:00',
        '12:01 - 16:00',
        '08:01 - 12:00',
        '04:01 - 08:00',
        '00:01 - 04:00'
      ];
      const damage = [];
      for (let i = 0; i < 42; i++) {
        damage.push([parseInt(i / 6), i % 6, 0]);
      }
      this.chartHeatmapOptions.series = { data: damage };
    },
    search() {
      this.getChartOptions();
      this.accidentItems = [];
      this.searchPie();
      this.searchHeatmap();
    },
    searchPie() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/accident/time_of_day`;
      // if (this.searchCondition && this.searchCondition.start_date)
      //   url += `start_date=${this.searchCondition.start_date}&`;
      // if (this.searchCondition && this.searchCondition.end_date)
      //   url += `end_date=${this.searchCondition.end_date}&`;

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.accidentItems = response.data.data.data;
          }
        })
        .catch(function(error) {
          scope.accidentItems = [];
          console.log(error);
        });
    },
    searchHeatmap() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/accident/day_of_week`;
      // if (this.searchCondition && this.searchCondition.start_date)
      //   url += `start_date=${this.searchCondition.start_date}&`;
      // if (this.searchCondition && this.searchCondition.end_date)
      //   url += `end_date=${this.searchCondition.end_date}&`;

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            const days = data.day;
            const times = data.time.reverse();
            let series = data.damage;
            series.data = series.data.map(el => {
              el[1] = 5 - el[1];
              return el;
            });

            scope.chartHeatmapOptions.xAxis.categories = days;
            scope.chartHeatmapOptions.yAxis.categories = times;
            scope.chartHeatmapOptions.series = series;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  watch: {
    searchCondition(value) {
      this.active_tab = value.search;
      this.search();
    },
    accidentItems(value) {
      this.sumDead = 0;
      this.sumCount = 0;
      this.sumInjury = 0;
      const damage = [];
      for (let i = 0; i < this.accidentItems.length; i++) {
        const item = this.accidentItems[i];
        this.sumDead += item.dead;
        this.sumInjury += item.injury;
        this.sumCount += item.count;
        damage.push({
          name: item.hour,
          y: item.count
        });
      }
      this.chartPieOptions.series.data = damage;
      this.chartPieOptions.title.text = this.sumCount ? '' : 'ไม่พบข้อมูล';
      this.chartPieOptions.colors = this.colors.slice(0, damage.length);

    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.v-tab {
  // background-color: white;
  color: #131313;
}

.v-tab.v-tab--active {
  // background-color: #ba4438;
  color: #ba4438;
  border-bottom: 1px solid #ba4438;
}

.search {
  float: right;
}

.detail {
  background: var(--v-brightgrey-base);
}

.number {
  color: #ba4438;
}

.chart {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle {
  width: 100%;
  // height: 600px;
  border-radius: 3px;
  border: solid 1px #ba4438;
}

.title-dropdown {
  color: white;
  background-color: #ba4438;
  padding: 16px 8px;
}

.charts {
  // height: 150px;
  width: 90%;
}

.charts-pie {
  height: 260px;
}

.v-expansion-panel-content {
  padding: 10px 0 0 0;
}
</style>
